/**
 * Selection rules for the question prompt card (`PromptCard`), kept out of the component so the
 * chat UI and the inbox share one definition and a plain unit test can cover them.
 */

/**
 * Multi-select only applies when the agent asked for it (`multiple: true`) *and* it gave choices.
 * A multi-select prompt with no options is just a free-text question, and a `multiple` flag on a
 * permission prompt means nothing.
 */
export function isMultiSelect(prompt: { multiple?: boolean; options?: unknown[] }): boolean {
  return prompt.multiple === true && (prompt.options?.length ?? 0) > 0
}

/** Adds a label, or removes it if it was already picked. Keeps the order the user clicked in. */
export function toggleLabel(picked: string[], label: string): string[] {
  return picked.includes(label) ? picked.filter(l => l !== label) : [...picked, label]
}

/**
 * What a multi-select answer sends back: the picked labels, comma-separated, with any typed answer
 * appended. The core's `question` tool documents "the selected label(s)", and the model reads one
 * line, so a list — not a count and not one label — is what it needs. Empty parts are dropped, so
 * a typed answer alone is a valid answer and nothing picked or typed yields '' (send nothing).
 */
export function selectionAnswer(picked: string[], custom = ''): string {
  return [...picked, custom.trim()].filter(Boolean).join(', ')
}
